import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyIntegrationsModel }        from '../companies/models/company.integrations';
import { PartsAuthorityService }           from './parts-authority.service';
import { PartsAuthoritySettingsComponent } from './parts-authority.settings.component';
import { SessionModel }                    from '../sessions/models/session';
import { SessionService }                  from '../sessions/session.service';

export const PartsAuthorityStates : Array<NgHybridStateDeclaration> = [
  {
    component: PartsAuthoritySettingsComponent,
    name     : 'app.parts-authority-settings',
    resolve  : [
      {
        deps     : [ PartsAuthorityService ],
        resolveFn: ( partsAuthorityService : PartsAuthorityService ) : Promise<CompanyIntegrationsModel> => partsAuthorityService.getIntegrations(),
        token    : 'integrations'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<SessionModel> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/parts-authority-settings'
  }
];
